// extracted by mini-css-extract-plugin
export default {"Slot":"Slot_Slot__4V916","Highlighted":"Slot_Highlighted__KJnMc"};